import { Container } from "@/components/atoms";
import { PageHeader, SoloOperatorGetStartedPanel } from "@/components/organisms";

export const SoloOperatorGetStarted = () => {
  return (
    <>
      <div className="sticky top-0 z-20 -mx-3 border-b border-neutral-mid-gray bg-white lg:-mx-5">
        <PageHeader className="!mx-0 px-3 lg:px-5" title="Get Started" skipCrumbs={1} />
      </div>
      <div className="-mx-3 flex-1 bg-neutral-surface-gray lg:-mx-5">
        <div className="px-3 lg:px-5">
          <Container className="w-full">
            <SoloOperatorGetStartedPanel />
          </Container>
        </div>
      </div>
    </>
  );
};
